<template>
  <div>
    <div class="">
      <div class>
        <header class="bg-white">
          <div class="top-bar-area theme-bg" >
            <div class="container" style="padding: 0;">
              <div class="row">
                <div style="padding-left: 0px" class="col-md-12 col-lg-6 teste123">
                  <a href="https://www.lefisc.com.br" target="_blank">
                    <img
                      class="logo-main"
                      src="https://www.lefisc.com.br/monitoramentoncm/img/logo.png"
                      style
                      alt
                      v-if="width > 360"
                    />
                    <img
                      class="logo-main"
                      src="https://www.lefisc.com.br/monitoramentoncm/img/bolota.png"
                      style
                      alt
                      v-if="width <= 360"
                    />
                  </a>
                  
                  <span id="titulopagina">
                    <router-link :to="{name: 'Home'}">
                    <b class="titulo-principal titulomenu">Monitoramento NCM</b></router-link>
                    <ul class="d-inline" v-if="width <= 769">
                      <li
                        class="cursor d-inline"
                        v-if="width <= 769"
                        @click="toggleMenu = !toggleMenu"
                      >
                        <i class="fas fa-bars hamburguer"></i>
                      </li>
                    </ul>
                  </span>
                </div>
                <div class="col-md-6 text-right">
                  <ul v-if="width > 769">
                    <li style="vertical-align: middle" class="boxMenu text-right linkmenu" v-for="rota in rotas" :key="rota.id">
                      <router-link
                        :to="rota.path ? rota.path:'/'"
                        v-if="width > 769"
                      >{{ rota.name }}</router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="bordaMenu pt-3">
              <div class="mt-0" v-for="rota in rotas" :key="rota.id">
                <transition name="exibir">
                  <ul class="col-12 menuCelular p-1" v-if="width <= 769 && toggleMenu">
                    <li>
                      <router-link class="link" :to="rota.path ? rota.path:'/'">{{ rota.name }}</router-link>
                    </li>
                  </ul>
                </transition>
              </div>
            </div>
          </div>
        </header>
        <!-- header end -->
      </div>
    </div>
  </div>
</template>
<script>
//import linkMenu from "./linkMenu.vue";
//import serviceMenuTopo from "../../services/serviceMenuTopo.js";
export default {
  props: {
    rotas: {
      type: Array,
      required: true
    }
  },
  components: {
    //linkMenu: linkMenu
  },
  async created() {
    //menu hamburguer
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  data() {
    return {
      nomeProduto: null,
      menuCollapsed: false,
      showMenu: false,
      menuProduto: null,
      width: "",
      toggleMenu: false
      // menuOriginal:[{nome:'Regulamento', endereco:'teste'},{nome:'Home', endereco:'teste'},{nome:'Anexos', endereco:'teste'},{nome:'Apêndices RICMS', endereco:'teste'},{nome:'Principais Normas', endereco:'teste'},{nome:'A-Z Índice alfabético', endereco:'teste'}],
    };
  },

  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    handleResize() {
      this.width = window.innerWidth;
    }
  }
};
</script>
<style scoped>
@media (min-width: 992px) {
  .titulo {
    font-size: 20px !important;
    font-weight: 600 !important;
    color: black;
    padding-left: 0px !important;
    margin-right: 0px;
  }
}

@media (max-width: 768px) {
  .titulo {
    padding: 0em !important;
    font-size: 20px !important;
  }

  .mobile {
    display: inline !important;
  }
  .menuItens {
    background-color: #fff;
    padding: 0 !important;
  }
  .menuItens a {
    padding-top: 2em !important;
    padding-bottom: 2em !important;
    border-bottom: #333333 1px solid;
  }
  .menuItens a:hover,
  .menuItens a:focus {
    background-color: #bfbfbf;
    color: #fff !important;
  }
  .barraMenu {
    display: none;
  }
  .notificacao {
    position: relative;
    left: 0.2em !important;
    top: -0.7em;
  }
}
#menu .links:nth-child(2) {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: black;
}
.mobile {
  display: none;
}
.notificacao {
  position: relative;
  left: -0.4em;
  top: -0.7em;
}
.titulo {
  font-size: 20px;
  font-weight: 600;
  color: black;
  padding-left: 10px;
  position: fixed !important;
}

.titulomenu {
  border-left: solid 0.7px #808080;
  padding: 0 0 0 10px;
  margin: 0 0 0 13px;
}

.panel-heading {
  padding-right: 0 !important;
}
.botaoNovaEmpresa {
  width: 12em;
}
.imagem {
  width: 103px;
  height: 25px;
}
.barraMenu {
  height: 55px;
  position: relative;
}
.teste {
  position: relative;
  bottom: 0.7em;
}
.main-menu {
  position: relative;
}

.main-menu div {
  display: inline-block;
  line-height: 1;
  position: relative;
  padding-top: 10px;
}

.main-menu div a {
  color: black;
  font-size: 13px;
  line-height: 1;
  padding: 0.5em;
  display: inline-block;
  text-transform: capitalize;
  position: relative;
  vertical-align: middle;
}

.main-menu a:hover {
  color: #0876b6;
}
.main-menu a:focus {
  color: #0876b6;
}

.linhaDivisoria::after {
  content: "";
  position: absolute;
  background: gray;
  height: 22px;
  width: 1px;
  left: 9.68em;
  top: 50%;
  transform: translateY(-50%);
}
.links {
  margin: 0 0.3em;
}

.top-bar-area {
  height: 56px;
}

.container {
  max-width: 1140px;
}

.hamburguer {
  font-size: 20px;
  float: right;
}
.cursor {
  cursor: pointer;
}
.logo-main {
  color: black;
  width: 103px;
}

.menuCelular {
  background-color: white;
  text-align: center;
}

.exibir-enter,
.exibir-leave-to {
  min-height: 0;
  max-height: 0;
  opacity: 0;
}

.exibir-enter-to,
.exibir-leave {
  min-height: 10px;
  max-height: 100px;
  opacity: 1;
}

.exibir-leave-active,
.exibir-enter-active {
  transition: all 0.4s;
}

.bordaMenu ul {
  border-top: 1px solid rgb(236, 236, 236);
  border-bottom: 1px solid rgb(236, 236, 236);
  width: 100%;
}

.link {
  color: rgb(56, 56, 56);
  font-weight: bold;
}

.link:hover {
  color: #17a2b8;
  transition: 0s;
}

.menutopo {
  min-height: 58px;
  margin-bottom: 58px;
  background-color: white;
}

.linkmenu a {
  color: black;
  transition: 1s color;
}

.linkmenu a:hover {
  color: #0876b6;
}

.linkmenu2 a {
  color: #0876b6;
}

.pt-3 {
  padding-top: 0.9rem !important;
}

.titulo-principal {
  vertical-align: middle;
  color: rgb(56, 56, 56);
  transition: 1s color;
}

.titulo-principal:hover {
    cursor: pointer; 
    color: #0876b6
    
  }

@media (max-width: 360px) {
  
  .logo-main {
    height: 30px;
    width: 30px;
  }
}
</style>